import React, {Component} from 'react';
import PropTypes from 'prop-types';
import JobInputTitle from './JobInputTitle';
import {Field} from 'redux-form';
import TextField from 'material-ui/TextField';

const jobStringInputStyles = {
    container: {margin: '0 0 1em 0'}
}

class JobStringInput extends Component {
    constructor(props) {
        super(props);
        let value = (props.defaultValue) ? props.defaultValue : '';
        if (props.value) {
            value = props.value;
        }

        this.state = {
            errorText: null,
            value: value
        };
    }

    handleChange = (e) => {
        const value = e.target.value;
        let error = (this.props.required && (!value || value === ''));

        this.setState({
            errorText: (error) ? 'Required' : null,
            value: value
        }, () => {
            if (typeof this.props.onChange === 'function') {
                this.props.onChange(this.props.customType, this.props.name, value);
            }
        });
    };

    render() {
        const {
            allowOverride,
            customType,
            defaultValue,
            disabled,
            label,
            multiline,
            name,
            param,
            required,
            rows,
            style,
            tooltip,
            value
        } = this.props;

        const {
            errorText
        } = this.state;

        return (
            <div style={jobStringInputStyles.container}>
                <JobInputTitle label={label} tooltip={tooltip}/>

                {!multiline &&
                    <Field
                        key={`job-report-param-${customType}-${param}`}
                        label={`${label}${(required) ? ' *' : ''}`}
                        floatingLabelText={`${label}${(required) ? ' *' : ''}`}
                        name={name}
                        component={TextField}
                        type="text"
                        defaultValue={(defaultValue) ? defaultValue : undefined}
                        props={{
                            onChange: this.handleChange,
                            required: required,
                            value: (value) ? value : (allowOverride) ? '' : undefined
                        }}
                        required={required}
                        disabled={(disabled) ? true : undefined}
                        errorText={errorText}
                        style={style}
                    />
                }
                {multiline &&
                    <TextField
                        key={`job-report-param-${customType}-${param}`}
                        variant="filled"
                        label={`${label}${(required) ? ' *' : ''}`}
                        floatingLabelText={`${label}${(required) ? ' *' : ''}`}
                        name={name}
                        type="text"
                        multiLine={true}
                        rows={rows}
                        defaultValue={(defaultValue) ? defaultValue : undefined}
                        value={(value) ? value : (allowOverride) ? '' : undefined}
                        onChange={this.handleChange}
                        required={required}
                        disabled={(disabled) ? true : undefined}
                        errorText={errorText}
                        style={style}
                    />
                }
            </div>
        )
    }
}

JobStringInput.propTypes = {
    allowOverride: PropTypes.bool,
    customType: PropTypes.string,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    multiline: PropTypes.bool,
    name: PropTypes.string,
    nativeType: PropTypes.string,
    onChange: PropTypes.func,
    param: PropTypes.string,
    required: PropTypes.bool,
    rows: PropTypes.number,
    style: PropTypes.object,
    tooltip: PropTypes.string,
    value: PropTypes.string
};

JobStringInput.defaultProps = {
    allowOverride: false,
    disabled: false,
    multiline: false,
    name: 'location',
    param: 'location',
    nativeType: 'str',
    required: false,
    style: {}
};

export default JobStringInput;



// WEBPACK FOOTER //
// ./src/Fuse/components/JobStringInput.js